var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticClass: "table-product",
    attrs: {
      value: _vm.value,
      headers: _vm.headers,
      items: _vm.items,
      "items-per-page": _vm.perPage,
      loading: _vm.loading,
      "hide-default-footer": "",
      "mobile-breakpoint": "0",
      "item-key": "id",
      "show-select": "",
    },
    on: {
      "toggle-select-all": function ($event) {
        return _vm.selectAll($event)
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: `header.data-table-select`,
          fn: function ({ on }) {
            return [
              _c(
                "v-simple-checkbox",
                _vm._g(
                  {
                    staticClass: "mt-0",
                    attrs: {
                      value: _vm.isSelectedAll,
                      ripple: false,
                      color: "primary",
                      height: "29px",
                      "hide-details": "",
                    },
                  },
                  on
                )
              ),
            ]
          },
        },
        {
          key: `item.data-table-select`,
          fn: function ({ item }) {
            return [
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                [
                  _c("v-simple-checkbox", {
                    staticClass: "mt-0",
                    style: {
                      height: _vm.hasSubproduct(item)
                        ? _vm.getHeight([item.name.length], 28) + "px"
                        : "auto",
                    },
                    attrs: {
                      value: _vm.printable
                        ? _vm.$_.every(
                            item.subproducts,
                            (sub) => !!_vm.$_.find(_vm.value, { id: sub.id })
                          )
                        : !!_vm.$_.find(_vm.value, { id: item.id }),
                      disabled: _vm.printable
                        ? _vm.$_.every(item.subproducts, (sub) => !sub.barcode)
                        : _vm.$_.every(item.subproducts, (sub) => sub.barcode),
                      ripple: false,
                      color: "primary",
                      "hide-details": "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.selectProduct({
                          item,
                          value: $event,
                        })
                      },
                    },
                  }),
                  _vm.printable && _vm.hasSubproduct(item)
                    ? _vm._l(item.subproducts, function (subproduct) {
                        return _c("v-simple-checkbox", {
                          key: subproduct.id,
                          staticClass: "mt-0",
                          style: {
                            height: _vm.hasSubproduct(item)
                              ? _vm.getHeight([subproduct.name.length], 24) +
                                "px"
                              : "auto",
                          },
                          attrs: {
                            value: _vm.$_.find(_vm.value, { id: subproduct.id })
                              ? true
                              : false,
                            ripple: false,
                            disabled: !subproduct.barcode,
                            color: "primary",
                            "hide-details": "",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.selectSubProduct(subproduct)
                            },
                          },
                        })
                      })
                    : _vm._e(),
                ],
                2
              ),
            ]
          },
        },
        {
          key: `item.code`,
          fn: function ({ item }) {
            return [
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "font-weight-medium",
                      style: {
                        minHeight: _vm.hasSubproduct(item)
                          ? _vm.getHeight([item.name.length], 28) + "px"
                          : "auto",
                      },
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            disabled: !_vm.hasSubproduct(item),
                            transition: "fade-transition",
                            bottom: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            class: {
                                              "text-overflow--1":
                                                _vm.hasSubproduct(item),
                                            },
                                          },
                                          "div",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v(" " + _vm._s(item.code) + " ")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c(
                            "v-card",
                            {
                              attrs: {
                                "max-width": "300",
                                color: "transparent",
                                flat: "",
                                dark: "",
                              },
                            },
                            [_vm._v(" " + _vm._s(item.code) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.hasSubproduct(item)
                    ? _vm._l(item.subproducts, function (subproduct) {
                        return _c(
                          "div",
                          {
                            key: subproduct.id,
                            staticClass: "body-2 font-weight-regular",
                            style: {
                              minHeight: _vm.hasSubproduct(item)
                                ? _vm.getHeight([subproduct.name.length], 24) +
                                  "px"
                                : "auto",
                            },
                          },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  transition: "fade-transition",
                                  bottom: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass:
                                                    "text-overflow--1",
                                                },
                                                "div",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(subproduct.code) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "v-card",
                                  {
                                    attrs: {
                                      "max-width": "300",
                                      color: "transparent",
                                      flat: "",
                                      dark: "",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(subproduct.code) + " ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                ],
                2
              ),
            ]
          },
        },
        {
          key: `item.name`,
          fn: function ({ item }) {
            return [
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "font-weight-medium",
                      style: {
                        minHeight: _vm.hasSubproduct(item)
                          ? _vm.getHeight([item.name.length], 28) + "px"
                          : "auto",
                      },
                    },
                    [_vm._v(" " + _vm._s(item.name) + " ")]
                  ),
                  _vm.hasSubproduct(item)
                    ? _vm._l(item.subproducts, function (subproduct) {
                        return _c(
                          "div",
                          {
                            key: subproduct.id,
                            staticClass: "body-2 font-weight-regular",
                            style: {
                              minHeight: item.subproducts.length
                                ? _vm.getHeight([subproduct.name.length], 24) +
                                  "px"
                                : "auto",
                            },
                          },
                          [_vm._v(" " + _vm._s(subproduct.name) + " ")]
                        )
                      })
                    : _vm._e(),
                ],
                2
              ),
            ]
          },
        },
        {
          key: `item.barcode`,
          fn: function ({ item }) {
            return [
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "font-weight-medium",
                      style: {
                        minHeight: _vm.hasSubproduct(item)
                          ? _vm.getHeight([item.name.length], 28) + "px"
                          : "auto",
                      },
                    },
                    [
                      !_vm.hasSubproduct(item)
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: {
                                transition: "fade-transition",
                                bottom: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "text-overflow--1",
                                              },
                                              "div",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.subproducts[0].barcode
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  attrs: {
                                    "max-width": "300",
                                    color: "transparent",
                                    flat: "",
                                    dark: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.subproducts[0].barcode) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.hasSubproduct(item)
                    ? _vm._l(item.subproducts, function (subproduct) {
                        return _c(
                          "div",
                          {
                            key: subproduct.id,
                            staticClass: "body-2 font-weight-regular",
                            style: {
                              minHeight: _vm.hasSubproduct(item)
                                ? _vm.getHeight([subproduct.name.length], 24) +
                                  "px"
                                : "auto",
                            },
                          },
                          [_vm._v(" " + _vm._s(subproduct.barcode) + " ")]
                        )
                      })
                    : _vm._e(),
                ],
                2
              ),
            ]
          },
        },
        _vm.totalPages > 1 && !_vm.loading
          ? {
              key: "footer",
              fn: function () {
                return [
                  _c("snt-pagination", {
                    attrs: {
                      "total-pages": _vm.totalPages,
                      "total-visible": 7,
                    },
                    model: {
                      value: _vm.paginationPage,
                      callback: function ($$v) {
                        _vm.paginationPage = $$v
                      },
                      expression: "paginationPage",
                    },
                  }),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }